import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SEOMeta from '@/components/feature/SEOMeta';
import HeroSection from './components/HeroSection';
import HotMangaSection from './components/HotMangaSection';
import CategorySection from './components/CategorySection';
import LatestUpdateSection from './components/LatestUpdateSection';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <SEOMeta
        title="韩漫漫画网-韩漫在线阅读_免费的韩国漫画_无删减下拉式韩漫大全"
        description="在韩漫漫画网进行韩漫在线阅读，您可以畅享免费的韩国漫画和无删减下拉式韩漫大全，故事情节完整原汁原味。海量韩漫资源每日更新，分类齐全，阅读体验流畅。"
        keywords="韩漫漫画网,韩漫在线阅读,免费的韩国漫画,无删减下拉式韩漫大全"
        canonicalUrl="https://hanmanmh.com/"
        ogTitle="韩漫漫画网-韩漫在线阅读_免费的韩国漫画_无删减下拉式韩漫大全"
        ogDescription="在韩漫漫画网进行韩漫在线阅读，您可以畅享免费的韩国漫画和无删减下拉式韩漫大全，故事情节完整原汁原味。"
      />
      <Navbar />
      <main>
        <HeroSection />
        <HotMangaSection />
        <CategorySection />
        <LatestUpdateSection />
      </main>
      <Footer />
    </>
  );
}